export default {"src":"/_next/static/media/sand_watch.a7ba3446.svg","height":132,"width":78,"blurWidth":0,"blurHeight":0};